import React, { Suspense, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Switch, useLocation } from 'react-router-dom';

import { Navbar } from '../components';
import { RouteIf } from '../router/RouteIf';

const Home = React.lazy(() =>
	import('../pages/Home').then((m) => ({ default: m.Home })),
);
const Project = React.lazy(() =>
	import('../pages/Project').then((m) => ({ default: m.Project })),
);
const Report = React.lazy(() =>
	import('../pages/Report').then((m) => ({ default: m.Report })),
);
const Requests = React.lazy(() =>
	import('../pages/Request').then((m) => ({ default: m.Requests })),
);
const OnePager = React.lazy(() =>
	import('../pages/OnePager').then((m) => ({ default: m.OnePager })),
);
const OnePager2 = React.lazy(() =>
	import('../pages/OnePager2').then((m) => ({ default: m.OnePager2 })),
);
const Person = React.lazy(() =>
	import('../pages/Person').then((m) => ({ default: m.Person })),
);
const Squad = React.lazy(() =>
	import('../pages/Squad').then((m) => ({ default: m.Squad })),
);
const Talent = React.lazy(() =>
	import('../pages/Talent').then((m) => ({ default: m.Talent })),
);
const ProjectNextQ = React.lazy(() =>
	import('../pages/ProjectNextQ').then((m) => ({ default: m.ProjectNextQ })),
);
const ProjectPreviousQ = React.lazy(() =>
	import('../pages/ProjectPreviousQ').then((m) => ({
		default: m.ProjectPreviousQ,
	})),
);
const Admin = React.lazy(() =>
	import('../pages/Admin').then((m) => ({ default: m.Admin })),
);
const Program = React.lazy(() =>
	import('../pages/Program').then((m) => ({ default: m.Program })),
);
const LoadConfigs = React.lazy(() =>
	import('../pages/LoadConfigs').then((m) => ({ default: m.LoadConfigs })),
);
const StaffingReports = React.lazy(() =>
	import('../pages/StaffingReports').then((m) => ({
		default: m.StaffingReports,
	})),
);

import { wsActions } from '../helpers/utils';
import { websocket } from '../redux/actions/websocket';

const TalentRequest = React.lazy(() =>
	import('../pages/TalentRequest').then((m) => ({ default: m.TalentRequest })),
);
const Candidates = React.lazy(() =>
	import('../pages/Candidates').then((m) => ({ default: m.Candidates })),
);
const External = React.lazy(() =>
	import('../pages/External').then((m) => ({ default: m.External })),
);
const Logout = React.lazy(() =>
	import('../pages/Logout').then((m) => ({ default: m.Logout })),
);
const Tribus = React.lazy(() =>
	import('../pages/Tribus').then((m) => ({ default: m.Tribus })),
);

const CecoArea = React.lazy(() =>
	import('../pages/CecoArea').then((m) => ({ default: m.CecoArea })),
);

const GestionPermisos = React.lazy(() =>
	import('../pages/GestionPermisos').then((m) => ({
		default: m.GestionPermisos,
	})),
);
const Perfiles = React.lazy(() =>
	import('../pages/Perfiles').then((m) => ({ default: m.Perfiles })),
);
const Proveedores = React.lazy(() =>
	import('../pages/Proveedores').then((m) => ({ default: m.Proveedores })),
);
const Parametros = React.lazy(() =>
	import('../pages/Parametros').then((m) => ({ default: m.Parametros })),
);
const TalentByProyect = React.lazy(() =>
	import('../pages/TalentByProyect').then((m) => ({
		default: m.TalentByProyect,
	})),
);
const Execution = React.lazy(() =>
	import('../pages/Execution').then((m) => ({ default: m.Execution })),
);
const Cal = React.lazy(() =>
	import('../pages/Cal/Index').then((m) => ({ default: m.Cal })),
);

export const DashboardRoutes = () => {
	const dispatch = useDispatch();
	const { urls, initialUrl } = useSelector((state: any) => state.uReducer);
	const { wsClient } = useSelector((state: any) => state.wsReducer);
	const location = useLocation();
	let Componente: React.ReactNode;
	const renderWithTitle = (Component: unknown, title: string) =>
		React.createElement(Component as React.ComponentType<any>, { title });

	const getInitUrl = (initial: string) => {
		const clean = (url: string) => url.replace(/\/{2,}/g, '/');

		if (initial) return clean(initial);

		const base = process.env.REACT_APP_PUBLIC_URL?.replace(/\/+$/, '') || '';
		return clean(`${base}/loadconfigs`);
	};

	const initUrl = getInitUrl(initialUrl);
	const grantedUrls = urls ? urls.split(',') : [];
	const hasAccess =
		location.pathname === '/' ||
		location.pathname === '/loadconfigs' ||
		grantedUrls.includes('/*') ||
		grantedUrls.includes(location.pathname);

	useEffect(() => {
		if (location.pathname !== '/' && wsClient?.url === undefined) {
			const wsClient2 = wsActions();
			dispatch(websocket(wsClient2));
		}
	}, [dispatch, location.pathname, wsClient?.url]);

	switch (location.pathname) {
		case '/home':
			Componente = renderWithTitle(Home, 'Inicio');
			break;
		case '/onepager':
			Componente = renderWithTitle(OnePager, 'One pager');
			break;
		case '/programs':
			Componente = renderWithTitle(Program, 'Programas');
			break;
		case '/onepager2':
			Componente = renderWithTitle(OnePager2, 'One pager 2');
			break;
		case '/persons':
			Componente = renderWithTitle(Person, 'Personas');
			break;
		case '/projects':
			Componente = renderWithTitle(Project, 'Proyectos');
			break;
		case '/reports':
			Componente = renderWithTitle(Report, 'Reportes');
			break;
		case '/requests':
			Componente = renderWithTitle(Requests, 'Consulta requerimientos');
			break;
		case '/squads':
			Componente = renderWithTitle(Squad, 'Squads');
			break;
		/* case '/surcease':
      Componente = <Surcease title="Ceses" />;
      break; */
		case '/talent':
			Componente = renderWithTitle(Talent, 'Talentos');
			break;
		case '/projects-nextq':
			Componente = renderWithTitle(ProjectNextQ, 'Proyectos para el próximo Q');
			break;
		case '/admin':
			Componente = renderWithTitle(Admin, 'Gestión');
			break;
		case '/staffingReports':
			Componente = renderWithTitle(StaffingReports, 'Reporte Staffing');
			break;
		case '/talent-requests':
			Componente = renderWithTitle(TalentRequest, 'Solicitud de talentos');
			break;
		case '/candidates':
			Componente = renderWithTitle(Candidates, 'Candidatos');
			break;
		case '/project-assignment':
			Componente = renderWithTitle(External, 'Asignación de proyectos');
			break;
		case '/logout':
			Componente = renderWithTitle(Logout, 'Cerrando sesión');
			break;
		case '/projects-prevq':
			Componente = renderWithTitle(
				ProjectPreviousQ,
				'Importar proyectos del Q anterior',
			);
			break;
		case '/tribus':
			Componente = renderWithTitle(Tribus, 'Tribus');
			break;
		case '/ceco-areas':
			Componente = renderWithTitle(CecoArea, 'CecoArea');
			break;
		case '/gestion-permisos':
			Componente = renderWithTitle(GestionPermisos, 'Gestion de Roles');
			break;
		case '/perfiles':
			Componente = renderWithTitle(Perfiles, 'Perfiles');
			break;
		case '/proveedores':
			Componente = renderWithTitle(Proveedores, 'Proveedores');
			break;
		case '/parametros':
			Componente = renderWithTitle(Parametros, 'Parametros');
			break;
		case '/talentoxproyecto':
			Componente = renderWithTitle(TalentByProyect, 'Talentos por Proyecto');
			break;
		case '/execution':
			Componente = renderWithTitle(Execution, 'Gestión de Execution');
			break;
		case '/cal':
			Componente = renderWithTitle(Cal, 'Gestión de CAL');
			break;
		default:
			Componente = renderWithTitle(LoadConfigs, 'Cargando configuraciones...');
			break;
	}

	return (
		<Suspense fallback={null}>
			{location.pathname !== '/' && <Navbar />}
			<Switch>
				<RouteIf
					path={location.pathname}
					condition={hasAccess}
					render={() => Componente}
					redirect={initUrl}
				/>
			</Switch>
		</Suspense>
	);
};
